var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMaximize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_212_1625)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6665 12.0003C12.6665 11.2639 13.2635 10.667 13.9998 10.667L21.9998 10.6671C22.7362 10.6671 23.3332 11.264 23.3332 12.0004V20.0003C23.3332 20.7367 22.7362 21.3337 21.9998 21.3337H21.3332C20.965 21.3337 20.6665 21.0352 20.6665 20.667V15.667C20.6665 14.3784 19.6218 13.3337 18.3332 13.3337H13.3332C12.965 13.3337 12.6665 13.0352 12.6665 12.667V12.0003ZM8.6665 16.0004C8.6665 15.2641 9.26346 14.6671 9.99984 14.6671L17.9998 14.6671C18.7362 14.6671 19.3332 15.2641 19.3332 16.0005V24.0004C19.3332 24.7368 18.7362 25.3337 17.9998 25.3337H9.99984C9.26346 25.3337 8.6665 24.7368 8.6665 24.0004V16.0004Z",
    fill: "#6B7280"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_212_1625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMaximize);
export default __webpack_public_path__ + "static/media/ic_maximize.0fc7c25b283485c41340bbf7f200e8bb.svg";
export { ForwardRef as ReactComponent };